import { render, staticRenderFns } from "./tab9.vue?vue&type=template&id=0109c75d&"
import script from "./tab9.vue?vue&type=script&lang=js&"
export * from "./tab9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports